export const CATEGORY_LINKS = {
  PRODUCT_RESEARCH_TOOLS: "Product Research Tools",
  KEYWORD_AND_LISTING_TOOLS: "Keyword and Listing Tools",
  FREE_TOOLS: "Free Tools",
  TRENDS_AND_PRODUCT_IDEAS: "Trends & Product Ideas",
  LEARNING_OPPORTUNITIES: "Learning Opportunities",
  PARTNERSHIPS: "Partnerships",
  COMPANY: "Company",
  POLICIES: "Policies"
};

